import { Action } from 'redux';
import { PaymentActionTypes } from '../payment.types';
import { paymentHelper } from 'helpers';

export interface RemovePaymentResultAction extends Action<PaymentActionTypes.REMOVE_PAYMENT_RESULT> {
}

export function* removePaymentResultSaga() {
    yield paymentHelper.removeSuccessfulPaymentResult();
}